module.exports = __webpack_public_path__ + "5648173d7953e7d1c867636eadea52f0.svg";